var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { VaniEvent, MessagePayload } from "..";
import { Participant } from "../model/Participant";
import * as log from 'loglevel';
import { Track } from "../model/Track";
import { WebSocketBasicEvents } from "../websocket-handler/WebsocketHandler";
import { VaniEventListener } from "../utility/VaniEventListener";
import { Utility } from "../utility/Utility";
var CommunicationHandler = /** @class */ (function () {
    function CommunicationHandler(meetingHandler) {
        this.isStartAndSetupWithServerCalled = false;
        this.eventEmitter = new VaniEventListener();
        this.allParticipants = [];
        this.selfTracks = [];
        this.allTracks = [];
        this.isReachable = true;
        this.meetingHandler = meetingHandler;
    }
    CommunicationHandler.prototype.setMeetingStartRequest = function (_meetingStartRequest) {
        this.meetingStartRequest = _meetingStartRequest;
    };
    CommunicationHandler.prototype.setWebsocketCallHandler = function (_websocketCallHandler) {
        this.websocketCallHandler = _websocketCallHandler;
    };
    CommunicationHandler.prototype.setVideoCallHandler = function (_videoCallHandler) {
        this.videoCallHandler = _videoCallHandler;
    };
    CommunicationHandler.prototype.isReady = function () {
        return this.meetingStartRequest !== undefined;
    };
    CommunicationHandler.prototype.emitMessageToSource = function (emitType, payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.eventEmitter.emit(emitType, payload);
                return [2 /*return*/];
            });
        });
    };
    CommunicationHandler.prototype.getEventEmitter = function () {
        return this.eventEmitter;
    };
    CommunicationHandler.prototype.onAudioVideoStatusUpdated = function (data) {
        if (data.message && data.message.participant && data.message.participant.userId) {
            var participant = this.participantByUserId(data.message.participant.userId);
            if (participant) {
                participant.isVideoEnable = data.message.participant.isVideoEnable;
                participant.isAudioEnable = data.message.participant.isAudioEnable;
                this.emitMessageToSource(VaniEvent.OnAudioVideoStatusUpdated, participant);
            }
        }
    };
    CommunicationHandler.prototype.getSelfParticipant = function () {
        var _a;
        if (this.meetingStartRequest) {
            var participant = this.participantByUserId((_a = this.meetingStartRequest) === null || _a === void 0 ? void 0 : _a.userId);
            if (!participant) {
                participant = new Participant(this.meetingStartRequest.userId, this.meetingStartRequest.roomId, this.meetingStartRequest.userData, this.meetingStartRequest.isAdmin);
                participant.isWhiteboardBlockedByAdmin = !this.meetingStartRequest.defaultWhiteboardEditEnable;
                participant.isAudioBlockedByAdmin = this.meetingStartRequest.defaultAudioBlocked;
                participant.isVideoBlockedByAdmin = this.meetingStartRequest.defaultVideoBlocked;
                participant.isScreenshareBlockedByAdmin = this.meetingStartRequest.defaultScreenShareBlocked;
                participant.isRecordingUser = this.meetingStartRequest.isRecordingUser;
                this.addParticipantIfNotExist(participant);
            }
            return participant;
        }
        return undefined;
    };
    CommunicationHandler.prototype.downloadParticipantsData = function () {
        var _a;
        var obj = { type: WebSocketBasicEvents.GetAllParticipant, message: "" };
        (_a = this.websocketCallHandler) === null || _a === void 0 ? void 0 : _a.sendSocketMessage(WebSocketBasicEvents.GetAllParticipant, obj);
    };
    CommunicationHandler.prototype.onServerParticipants = function (data) {
        var _this = this;
        if (data && data.message) {
            var userIds = "";
            Object.entries(data.message).forEach(function (_a) {
                var userId = _a[0], participant = _a[1];
                userIds = userIds + " " + userId;
                _this.addParticipantIfNotExist(participant, false);
            });
            var allParticiapntsToBeRemove = this.allParticipants.filter(function (participant) { return (userIds.includes(participant.userId) === false); });
            allParticiapntsToBeRemove.forEach(function (participant) {
                _this.removeParticipant(participant, true);
            });
            this.emitMessageToSource(VaniEvent.OnAllParticipants, this.allParticipants);
        }
    };
    CommunicationHandler.prototype.getAllParticipants = function () {
        return this.allParticipants;
    };
    CommunicationHandler.prototype.participantByUserId = function (userId) {
        return this.allParticipants.find(function (participant) { return participant.userId === userId; });
    };
    CommunicationHandler.prototype.addParticipantIfNotExist = function (participant, shouldInfrom) {
        var _a;
        if (shouldInfrom === void 0) { shouldInfrom = false; }
        var oldParticipant = this.participantByUserId(participant.userId);
        if (oldParticipant) {
            oldParticipant = Object.assign(oldParticipant, participant);
            if (shouldInfrom) {
                this.emitMessageToSource(VaniEvent.OnParticipantDataUpdated, oldParticipant);
            }
            return oldParticipant;
        }
        else {
            participant = Object.assign(new Participant(participant.userId, participant.roomId, participant.userData, participant.isAdmin), participant);
            this.allParticipants.push(participant);
            if (shouldInfrom) {
                this.emitMessageToSource(VaniEvent.OnUserJoined, participant);
            }
            (_a = this.videoCallHandler) === null || _a === void 0 ? void 0 : _a.onParticipantUpdated();
            return participant;
        }
    };
    CommunicationHandler.prototype.removeParticipant = function (participant, shouldInfrom) {
        var _this = this;
        var _a;
        if (shouldInfrom === void 0) { shouldInfrom = false; }
        var tracks = this.getAllTracksForParticipant(participant);
        if (tracks) {
            tracks.forEach(function (track) {
                _this.removeTrack(track, shouldInfrom);
            });
        }
        Utility.deleteArrayObject(participant, this.allParticipants);
        (_a = this.videoCallHandler) === null || _a === void 0 ? void 0 : _a.onParticipantUpdated();
        if (shouldInfrom) {
            this.emitMessageToSource(VaniEvent.OnUserLeft, participant);
        }
    };
    CommunicationHandler.prototype.onUserLeft = function (data) {
        if (data && data.message && data.message.participant && data.message.participant.userId) {
            var participant = this.participantByUserId(data.message.participant.userId);
            if (participant) {
                this.removeParticipant(participant, true);
            }
        }
    };
    CommunicationHandler.prototype.getSelfTrackByType = function (trackKind) {
        return this.selfTracks.find(function (track) { return track.trackKind === trackKind; });
    };
    CommunicationHandler.prototype.getAllSelfTracks = function () {
        return this.selfTracks;
    };
    CommunicationHandler.prototype.getAllTracks = function () {
        return this.allTracks;
    };
    CommunicationHandler.prototype.getTrackById = function (trackId) {
        return this.allTracks.find(function (track) { return track.trackId === trackId; });
    };
    CommunicationHandler.prototype.getLocalTrackById = function (trackId) {
        return this.selfTracks.find(function (track) { return track.trackId === trackId; });
    };
    CommunicationHandler.prototype.getAllTracksForParticipant = function (participant) {
        return this.allTracks.filter(function (track) { var _a; return ((_a = track.participant) === null || _a === void 0 ? void 0 : _a.userId) === participant.userId; });
    };
    CommunicationHandler.prototype.removeTrack = function (track, shouldInfromVideoController) {
        var _a;
        if (shouldInfromVideoController === void 0) { shouldInfromVideoController = true; }
        if (shouldInfromVideoController && this.isStartAndSetupWithServerCalled && track.isLocalTrack) {
            (_a = this.videoCallHandler) === null || _a === void 0 ? void 0 : _a.stopTrack(track);
        }
        Utility.deleteArrayObject(track, this.allTracks);
        Utility.deleteArrayObject(track, this.selfTracks);
        this.emitMessageToSource(VaniEvent.OnTrackEnded, track);
    };
    CommunicationHandler.prototype.addUpdateRemoteTrack = function (track, participant, shouldInfromIfNotExist) {
        if (shouldInfromIfNotExist === void 0) { shouldInfromIfNotExist = false; }
        var oldTrack = this.getTrackById(track.trackId);
        if (oldTrack) {
            track = Object.assign(oldTrack, track);
        }
        else {
            track = Object.assign(new Track(participant, track.isLocalTrack, track.trackKind, track.track), track);
            this.allTracks.push(track);
        }
        track.participant = participant;
        if (shouldInfromIfNotExist) {
            this.emitMessageToSource(VaniEvent.OnTrack, track);
        }
        return track;
    };
    CommunicationHandler.prototype.addUpdateLocalTrack = function (track) {
        var _this = this;
        var _a;
        var oldTrack = this.getLocalTrackById(track.trackId);
        if (oldTrack) {
            oldTrack.updateTrackWithNewData(track);
            track = oldTrack;
        }
        else {
            track.track.onended = function (ev) {
                _this.removeTrack(track);
            };
            this.allTracks.push(track);
            this.selfTracks.push(track);
        }
        if (this.isStartAndSetupWithServerCalled) {
            (_a = this.videoCallHandler) === null || _a === void 0 ? void 0 : _a.sendTrack(track);
        }
        this.emitMessageToSource(VaniEvent.OnTrack, track);
    };
    CommunicationHandler.prototype.onOldMessages = function (data) {
        var _this = this;
        var oldMessages = [];
        if (data && data.messages && data.messages.length > 0) {
            data.messages.forEach(function (messageDict) {
                if (messageDict.message) {
                    oldMessages.push(_this.onMessage(messageDict.message, false));
                }
            });
        }
        this.emitMessageToSource(VaniEvent.OnOldMessages, oldMessages);
    };
    CommunicationHandler.prototype.onMessage = function (message, shouldInfromSource) {
        if (shouldInfromSource === void 0) { shouldInfromSource = true; }
        var messagePayload = new MessagePayload(message.message, message.to);
        messagePayload.extraData = message.extraData;
        messagePayload.senderUserId = message.sender;
        messagePayload.time = message.time;
        messagePayload.type = message.type;
        messagePayload.shouldPresist = message.shouldPresist;
        if (messagePayload.senderUserId) {
            messagePayload.sender = this.participantByUserId(messagePayload.senderUserId);
        }
        if (shouldInfromSource) {
            this.emitMessageToSource(VaniEvent.OnNewChatMessageReceived, messagePayload);
        }
        return messagePayload;
    };
    CommunicationHandler.prototype.sendWebSocketMessage = function (type, data) {
        var _a;
        (_a = this.websocketCallHandler) === null || _a === void 0 ? void 0 : _a.sendSocketMessage(type, data);
    };
    CommunicationHandler.prototype.onVideoCallWebSocketMessage = function (websocketMessage) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                (_a = this.videoCallHandler) === null || _a === void 0 ? void 0 : _a.onSocketMessage(websocketMessage);
                return [2 /*return*/];
            });
        });
    };
    CommunicationHandler.prototype.onReconnect = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                (_a = this.videoCallHandler) === null || _a === void 0 ? void 0 : _a.onReconnect();
                this.emitMessageToSource(VaniEvent.OnConnectionBack, {});
                return [2 /*return*/];
            });
        });
    };
    CommunicationHandler.prototype.onStartMeeingCalled = function () {
        var _a, _b, _c, _d;
        if (this.isStartAndSetupWithServerCalled) {
            return;
        }
        log.info("onStartAndSetupWithServerCalled");
        this.isStartAndSetupWithServerCalled = true;
        var data = { user: (_a = this.meetingStartRequest) === null || _a === void 0 ? void 0 : _a.userId };
        var startMeetingCalled = { message: data, type: WebSocketBasicEvents.OnStartMeetingCalled, to: (_b = this.meetingStartRequest) === null || _b === void 0 ? void 0 : _b.roomId };
        (_c = this.websocketCallHandler) === null || _c === void 0 ? void 0 : _c.sendSocketMessage(WebSocketBasicEvents.OnStartMeetingCalled, startMeetingCalled);
        var selfParticpant = this.getSelfParticipant();
        if (selfParticpant) {
            selfParticpant.isStartMeetingCalled = true;
        }
        (_d = this.videoCallHandler) === null || _d === void 0 ? void 0 : _d.init();
    };
    //Connection Recheck
    CommunicationHandler.prototype.onIceCandidateDisconnected = function () {
        if (this.internetReachbilityTimeout) {
            return;
        }
        this.internetReachbilityTimeout = window.setTimeout(this.checkIfInternetReachable, 200, 0);
    };
    CommunicationHandler.prototype.checkIfInternetReachable = function (count) {
        var _this = this;
        var _a;
        if (!this.meetingStartRequest) {
            (_a = this.meetingHandler) === null || _a === void 0 ? void 0 : _a.endAndDestory();
            return;
        }
        if (count === 2) {
            this.emitMessageToSource(VaniEvent.OnNotReachable, {});
        }
        this.isReachable = false;
        fetch(this.meetingStartRequest.urlToCheckInternetPresent, {
            method: 'GET',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(function (response) { return response.text(); })
            .then(function (data) { return _this.onApiResponded(count); })
            .catch(function (error) {
            var _a;
            count = count + 1;
            console.error('Error:', error);
            if (count > 35) {
                _this.emitMessageToSource(VaniEvent.OnReconectionTimeout, {});
                (_a = _this.meetingHandler) === null || _a === void 0 ? void 0 : _a.endAndDestory();
                return;
            }
            _this.internetReachbilityTimeout = window.setTimeout(_this.checkIfInternetReachable, 1000, count);
        });
        ;
    };
    CommunicationHandler.prototype.onApiResponded = function (count) {
        var _a, _b, _c;
        if (this.isReachable === false) {
            this.isReachable = true;
            this.internetReachbilityTimeout = undefined;
            if (count < 2 && ((_a = this.websocketCallHandler) === null || _a === void 0 ? void 0 : _a.isWebScoketConnected())) {
                (_b = this.videoCallHandler) === null || _b === void 0 ? void 0 : _b.reconnectedWithoutPing();
                return;
            }
            (_c = this.websocketCallHandler) === null || _c === void 0 ? void 0 : _c.reconnectOnInternetFailur();
        }
    };
    CommunicationHandler.prototype.cleanup = function () {
        this.eventEmitter.removeAllListeners();
        this.videoCallHandler = undefined;
        this.meetingStartRequest = undefined;
        this.websocketCallHandler = undefined;
        this.meetingHandler = undefined;
    };
    return CommunicationHandler;
}());
export { CommunicationHandler };
